import React from "react";
import {useHistory, useParams, useRouteMatch} from "react-router-dom";

export default function BlockAddQuestionLandingScreen() {
    const history = useHistory();
    const {url} = useRouteMatch();
    const param = useParams();


    const goToQuestionList = () => {
        history.push(`${url}/question-list`);
    }
    return (
        <>
            <div className="flex justify-center addQuestionLandingScreen">
                <div className="flex flex-col gap-5">
                    <span className="text-lg">Start creating your question set now</span>
                    <button
                        onClick={() => goToQuestionList()}
                        className="w-30 mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold]
                        rounded-lg"
                    >
                        Create
                    </button>
                </div>
            </div>
        </>
    );
}
